import React, {useState} from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button, Textarea} from "@chakra-ui/react";
import {Header, Title} from "../sheet";
import useFeedback from "../../../utils/use_feedback";
import {useAddNote} from "../../../api/moderation";
import useModal from "../../../modals";

const CreateNoteSheet = styled(({className, username, community, onClose}) => {

        const {feedbackCh} = useFeedback();
        const modal = useModal();
        const [content, setContent] = useState('');
        const addNote = useAddNote(feedbackCh);
        const handleNote = async () => {
            try {
                await addNote(username, community, content);
            } catch {
            }
            onClose();
        };

        return (
            <div className={className}>

                <Header>
                    <Title>Create Note</Title>
                </Header>

                <Textarea
                    placeholder={''}
                    value={content}
                    onChange={(evn) => setContent(evn.target.value)}
                    height={'120px'}
                    autoComplete="off" />

                <Button variant={"grey"} style={{width: '100%', marginTop: '12px'}} onClick={handleNote}>Save</Button>

            </div>
        );
    }
)`
`;

export default CreateNoteSheet;
